import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { type ProblemContent } from '../lib/variants';

interface ProblemProps {
  content: ProblemContent;
}

const Problem: React.FC<ProblemProps> = ({ content }) => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl mb-4">
            {content.headline}
          </h2>
          <p className="text-xl text-gray-500 max-w-3xl mx-auto">
            {content.subheadline}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="rounded-2xl border-2 border-red-100 bg-red-50 p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-10 w-10 rounded-full bg-red-100 flex items-center justify-center">
                <XCircle className="h-6 w-6 text-red-500" />
              </div>
              <h3 className="text-xl font-bold text-gray-900">Bez AI — dzisiaj u Ciebie</h3>
            </div>
            <div className="space-y-4">
              {content.problems.map((step, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="mt-1 flex-shrink-0 h-6 w-6 rounded-full bg-red-200 flex items-center justify-center text-red-700 text-xs font-bold">
                    {i + 1}
                  </div>
                  <p className={`text-gray-700 ${i === content.problems.length - 1 ? 'font-bold text-red-700' : ''}`}>{step}</p>
                </div>
              ))}
            </div>
            <div className="mt-6 rounded-xl bg-red-100 p-4 text-sm font-semibold text-red-800">
              {content.problemResult}
            </div>
          </div>

          <div className="rounded-2xl border-2 border-cyan-200 bg-cyan-50 p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-10 w-10 rounded-full bg-cyan-100 flex items-center justify-center">
                <CheckCircle2 className="h-6 w-6 text-cyan-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900">Z AI — jak to działa po wdrożeniu</h3>
            </div>
            <div className="space-y-4">
              {content.solutions.map((step, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="mt-1 flex-shrink-0 h-6 w-6 rounded-full bg-cyan-400 flex items-center justify-center text-slate-950 text-xs font-bold">
                    {i + 1}
                  </div>
                  <p className={`text-gray-700 ${i === content.solutions.length - 1 ? 'font-bold text-cyan-700' : ''}`}>{step}</p>
                </div>
              ))}
            </div>
            <div className="mt-6 rounded-xl bg-cyan-100 p-4 text-sm font-semibold text-cyan-800">
              {content.solutionResult}
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-lg text-gray-600 font-medium">
            {content.bottomLine}
            <br />
            <span className="text-gray-900 font-bold">{content.bottomLineBold}</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Problem;
